import { type ReactNode } from 'react';
import { Typography } from '@mui/material';

type Props = { children: ReactNode };

// Sized here, not at each call site, so the whole editor moves together. 18px sits between the
// 16px input text and the 20px card title; MUI's subtitle2 is 14px and reads as a field label.
export default function SectionHeading({ children }: Props) {
    return (
        <Typography variant="subtitle1" sx={{ fontSize: '1.125rem', fontWeight: 500 }}>
            {children}
        </Typography>
    );
}
